import { Subject } from "rxjs";
import { FormBuilderOptions } from "./form-builder.model";

/**
 * App-wide signal: `showForm.next(opts)` opens the FormBuilder modal that the
 * mounted FormBuilderManager renders. Kept in its own module (not the .tsx) so
 * FormBuilderManager exports only its component — a React Fast Refresh requirement.
 */
export const showForm = new Subject<FormBuilderOptions | undefined>();
